
  <form [formGroup]="driverInfoForm" (ngSubmit)="onSubmit()">

    <!--Name-->
    <div class="form-group mb-lg-0 mb-md-0 row">
      <label class="col-12">{{ 'Name' | translate }}</label>
      <div class="col-md-4 pr-lg-0 mb-3">
        <input type="text" placeholder="{{ '1stName' | translate }}" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.firstName.errors }" />
        <div *ngIf="submitted && driverInfo.firstName.errors" class="invalid-feedback">
            <div *ngIf="driverInfo.firstName.errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
        </div>
      </div>
      <div class="col-md-4 pr-lg-0 mb-3">
        <input type="text"  placeholder="{{ '2ndName' | translate }}" formControlName="secondName" class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.secondName.errors }" />
        <div *ngIf="submitted && driverInfo.secondName.errors" class="invalid-feedback">
            <div *ngIf="driverInfo.secondName.errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
        </div>
      </div>
      <div class="col-md-4">
        <input type="text" placeholder="{{ 'FamilyName' | translate }}" formControlName="thirdName" class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.thirdName.errors }" />
        <div *ngIf="submitted && driverInfo.thirdName.errors" class="invalid-feedback">
            <div *ngIf="driverInfo.thirdName.errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
        </div>
      </div>
    </div>

    <!--Date of Birth-->
    <div class="form-group row">
      <label class="col-12">{{ 'DateofBirth' | translate }}</label>
      <div class="col-md-12">
        <div class="form-date">
          <mat-form-field appearance="none">
              <mat-datepicker-toggle matPrefix [for]="DateofBirth"></mat-datepicker-toggle>
              <mat-datepicker #DateofBirth></mat-datepicker>
              <input [max]="minDOB"  formControlName="DateofBirth" matInput  [matDatepicker]="DateofBirth" (click)="DateofBirth.open()" >
          </mat-form-field>
        </div>
        <div *ngIf="submitted && driverInfo.DateofBirth.errors" class="invalid-feedback">
            <div *ngIf="driverInfo.DateofBirth.errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
        </div>
      </div>
    </div>

    <!--Email-->
    <div class="form-group row">
      <label class="col-12">{{ 'Email' | translate }}</label>
      <div class="col-md-12">
        <input type="text" placeholder="email@domain.com" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.email.errors }" />
        <div *ngIf="submitted && driverInfo.email.errors" class="invalid-feedback">
            <div *ngIf="driverInfo.email.errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
            <div *ngIf="driverInfo.email.errors.email">{{ 'emailmustbeavalidemailaddressmsg' | translate }}</div>
        </div>
      </div>
    </div>

    <!--OldMobile Number
    <div class="form-group row">
      <label class="col-12">{{ 'MobileNumber' | translate }}</label>
      <div class="col-md-3 pr-0">
        <select formControlName="mobileCode" class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.mobileCode.errors }">
          <option value="code">code</option>
          <option value="079">079</option>
          <option value="078">078</option>
          <option value="077">077</option>
        </select>
        <div *ngIf="submitted && driverInfo.mobileCode.errors" class="invalid-feedback">
            <div *ngIf="driverInfo.mobileCode.errors.required">{{ 'ThisFiledIsRequired' | translate }}</div>
        </div>
      </div>
      <div class="col-md-9">
        <input type="text" formControlName="mobileNum" class="form-control" [ngClass]="{ 'is-invalid': submitted && driverInfo.mobileNum.errors }" />
        <div *ngIf="submitted && driverInfo.mobileNum.errors" class="invalid-feedback">
            <div *ngIf="driverInfo.mobileNum.errors.required">{{ 'ThisFiledIsRequired' | translate }}</div>
        </div>
      </div>
    </div>
  -->

    <!--Mobile Number-->
    <div class="form-group row">
      <label class="col-12">{{ 'MobileNumber' | translate }}</label>
      <div class="col-md-12">
      <ngx-intl-tel-input [cssClass]="'form-control border-0'"
        [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="true"
        [enablePlaceholder]="true"
        [searchCountryFlag]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
        [selectFirstCountry]="false"
        [selectedCountryISO]="CountryISO.India"
        [maxLength]="15"
        [tooltipField]="TooltipLabel.Name"
        [phoneValidation]="true"
        [separateDialCode]="separateDialCode"
        name="mobileNum"
        formControlName="mobileNum">
      </ngx-intl-tel-input>
      </div>
    </div>



    <div class="text-left mt-4">
      <button class="btn default-btn mr-3" mat-button>{{ 'Save' | translate }}</button>
      <button (click)="cancelClicked()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
    </div>

    
  </form>

